import * as XLSX from 'xlsx';

/**
 * Generate and download an Excel template for lesson plan import.
 */
export function generateLessonPlanTemplate(): void {
  const wb = XLSX.utils.book_new();

  // Sheet 1: Lesson Plan data with headers and sample rows
  const lessonPlanData = [
    ['Chapter', 'Section', 'Section Code', 'Start Date', 'End Date', 'Resource Name', 'Resource Type', 'Resource URL'],
    ['Introduction', 'What is Python?', 'WHAT_IS_PYTHON', '2025-06-01', '2025-06-03', 'Welcome Video', 'YouTube', 'https://www.youtube.com/watch?v=example1'],
    ['Introduction', 'What is Python?', '', '', '', 'Python Official Docs', 'Reference', 'https://docs.python.org'],
    ['Introduction', 'Setting Up Environment', 'SETTING_UP', '2025-06-04', '2025-06-05', '', '', ''],
    ['Data Types', 'Numbers and Strings', 'NUMBERS_STRINGS', '2025-06-06', '2025-06-08', 'Data Types Tutorial', 'YouTube', 'https://www.youtube.com/watch?v=example2'],
    ['Data Types', 'Lists and Dictionaries', 'LISTS_DICTS', '2025-06-09', '2025-06-11', 'Cheat Sheet PDF', 'Download', 'https://example.com/cheatsheet.pdf'],
  ];

  const lessonSheet = XLSX.utils.aoa_to_sheet(lessonPlanData);
  lessonSheet['!cols'] = [
    { wch: 20 }, // Chapter
    { wch: 25 }, // Section
    { wch: 20 }, // Section Code
    { wch: 12 }, // Start Date
    { wch: 12 }, // End Date
    { wch: 25 }, // Resource Name
    { wch: 15 }, // Resource Type
    { wch: 40 }, // Resource URL
  ];
  XLSX.utils.book_append_sheet(wb, lessonSheet, 'Lesson Plan');

  // Sheet 2: Instructions
  const instructionsData = [
    ['Column', 'Description'],
    ['Chapter', 'Chapter/Group name. Rows with the same chapter are grouped together. Leave empty to continue the previous chapter.'],
    ['Section', 'Section name within the chapter. Leave empty to add another resource to the previous section.'],
    ['Section Code', 'Optional code for the section. Auto-generated from the section name if omitted.'],
    ['Start Date', 'Section start date in YYYY-MM-DD format. Optional.'],
    ['End Date', 'Section end date in YYYY-MM-DD format. Optional.'],
    ['Resource Name', 'Name of the resource. Leave blank for sections without resources.'],
    ['Resource Type', 'Type of resource (see Valid Resource Types below). Required when Resource Name is provided.'],
    ['Resource URL', 'URL for the resource. Required for all types except Announcement.'],
    ['', ''],
    ['Valid Resource Types', 'Description'],
    ['Download', 'Downloadable file (PDF, DOC, etc.)'],
    ['Reference', 'External reference link'],
    ['Announcement', 'Text-based announcement (no URL needed)'],
    ['E-Book', 'E-Book link'],
    ['Video', 'Vimeo or general video link'],
    ['YouTube', 'YouTube video link'],
    ['', ''],
    ['Tips', ''],
    ['1', 'You can leave the Chapter column empty on subsequent rows to group them under the same chapter.'],
    ['2', 'You can leave the Section column empty to add more resources to the same section.'],
    ['3', 'A row with only Chapter and Section (no resource) creates an empty section.'],
    ['4', 'After importing, you can review and edit the lesson plan in the builder before saving.'],
  ];

  const instructionsSheet = XLSX.utils.aoa_to_sheet(instructionsData);
  instructionsSheet['!cols'] = [
    { wch: 22 }, // Column name
    { wch: 80 }, // Description
  ];
  XLSX.utils.book_append_sheet(wb, instructionsSheet, 'Instructions');

  XLSX.writeFile(wb, 'lesson-plan-import-template.xlsx');
}
